import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { deleteNotificationToken, notificationTokenMutation } from '../../../graph-ql/mutations';
import { NotificationTokenInput } from '../../models/lead/notificationTokenInput';

@Injectable()
export class NotificationService {

  constructor(private readonly apollo: Apollo) {
  }

  saveNotificationToken$(notificationTokenInput: NotificationTokenInput): any {
    return this.apollo
      .mutate<any>({
        mutation: notificationTokenMutation,
        variables: {
          input: {
            token: notificationTokenInput.token
          }
        }
      })
      .subscribe(result =>
        result['notificationToken']);
  }

  deleteNotificationToken$(): any {
    return this.apollo
      .mutate<any>({
        mutation: deleteNotificationToken,
      })
      .subscribe(result =>
        result['deleteNotificationToken']);
  }
}
